import { connect } from "react-redux";
import React, { Component } from "react";

import { closeModalGenericError } from "../../../actions/purchaseActions";

export class ModalGenericError extends Component {
    render() {
        if (!this.props.isModalGenericErrorActive) return <div />;

        return (
            <div className="comp_modalpagamento">
                <div className="modalcontents">
                    <div className="contents">
                        <div className="modaltop">
                            <div className="title">Erro Inesperado</div>

                            <div
                                onClick={this.props.closeModalGenericError}
                                className="close-btn"
                            >
                                {" "}
                                &times;{" "}
                            </div>
                        </div>

                        <div className="modalmiddle">
                            <p>
                                <img
                                    src="/assets/images/pagamento/alert.svg"
                                    alt="erro"
                                />
                            </p>
                            <p>
                                <strong>
                                    Ops! Algo não saiu como esperado!
                                </strong>
                            </p>
                            <p>
                                Tivemos um imprevisto ao processar sua solicitação, mas fica tranquilo:
                                não foi nada com você e seus dados estão seguros.
                            </p>
                            <p>
                                <strong>O que você pode fazer agora:</strong>
                                <ul style={{ listStyle: 'none', padding: 0, marginTop: '10px' }}>
                                    <li>• Tente novamente em alguns instantes</li>
                                    <li>• Atualize a página</li>
                                    <li>• Ou entre em contato com nosso atendimento</li>
                                </ul>
                            </p>
                            <p>
                                <h2>31 4003-8442</h2>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        isModalGenericErrorActive: state.purchase.isModalGenericErrorActive
    }),
    {
        closeModalGenericError
    }
)(ModalGenericError);


// WEBPACK FOOTER //
// ./src/components/purchase/modal_generic_error/ModalGenericError.jsx